import React, { useState, useEffect } from 'react';
import LogitechLogo from '@tc/assets/images/logitech-logo.png'
const AttractiveProduct = ({attractiveInfo}) => {
  return (
    <div className="attractive-product">
      <h3 className="title">{attractiveInfo.title}</h3>
      <div className="product-container">
        {
          attractiveInfo.productList.map((product, index) => {
            return <ProductCard product={product} key={index} />
          })
        }
      </div>
      
    </div>    
  )
}

const ProductCard = ({product}) => {
  return (
    <div className="product-card">
      <div className="card-title">{product.title}</div>
      <img className="product-img pc" src={product.img} />
      <img className="product-img mobile" src={product.mobileImg} />
      <div className="product-info">
        <div className="name">{product.name}</div>
        {/* <div className="qty">
          <span className="label">Qty:</span>
          <span className="desc">{product.qty}</span>
        </div> */}
        {/* <div className="worth">
          <span className="label">Worth:</span>
          <span className="desc">
            <span className="contry">SGD</span>
            <span className="money">{product.worth}</span>
          </span>
        </div> */}
      </div>
    </div>
  )
}

const ElevateProduct = ({elevateInfo}) => {
  return (
    <div className="elevate-container">
      <h3 className="title">{elevateInfo.title}</h3>
      {
        elevateInfo.productList.map((product, index) => {
          return(
            <div className="elevate-item">
              <img className="product-img" src={product.img} />
              <div className="product-info">
                <div className="main-title">{product.mainTitle}</div>
                <div className="sub-title">{product.subTitle}</div>
                <div className="desc">{product.desc}</div>
              </div>
            </div>
          )
        })
      }
      
    </div>
  )
}


const Sponsor = ({message}) => {

  return (
    <section id="sponsor">
      <h2 className="section-title">{message.title}</h2>
      <AttractiveProduct attractiveInfo={message.attractiveInfo} />
      <ElevateProduct elevateInfo={message.elevateInfo}/>
      <div className="logitech-desc">
        <span className="text">This event is proudly sponsored by</span>
        <img className="logo-img" src={LogitechLogo}/>
      </div>
    </section>
  )
};

export default Sponsor;